// Role translation utilities
export const getRoleLabel = (role) => {
  const roleLabels = {
    'MANAGER': 'Manager',
    'AGENT': 'Agent de Caisse',
    // 'VERIFICATION': 'Agent de Pointage', // Legacy role - commented out after migration
    'POINTAGE_CLIENT': 'Agent de Pointage Client',
    'POINTAGE_COMPTABILITE': 'Agent de Pointage Comptabilité'
  };
  return roleLabels[role] || role;
};

export const getRoleOptions = () => [
  { value: 'MANAGER', label: 'Manager' },
  { value: 'AGENT', label: 'Agent de Caisse' },
  // Legacy VERIFICATION role - commented out after migration
  // { value: 'VERIFICATION', label: 'Agent de Pointage' },
  { value: 'POINTAGE_CLIENT', label: 'Agent de Pointage Client' },
  { value: 'POINTAGE_COMPTABILITE', label: 'Agent de Pointage Comptabilité' }
];

// Caisse display utility for user lists with smart truncation
export const formatCaissesDisplay = (assignedCaisses, role, maxLength = 50) => {
  if (!assignedCaisses || assignedCaisses.length === 0) {
    return role === 'MANAGER' ? '' : 'Aucun';
  }
  
  if (assignedCaisses.length === 1) {
    const caisseName = assignedCaisses[0].name;
    return caisseName.length > maxLength ? `${caisseName.substring(0, maxLength - 3)}...` : caisseName;
  }
  
  if (assignedCaisses.length === 2) {
    const combined = assignedCaisses.map(c => c.name).join(', ');
    if (combined.length <= maxLength) {
      return combined;
    }
    
    // Smart truncation: try to fit first caisse + part of second
    const firstCaisse = assignedCaisses[0].name;
    const secondCaisse = assignedCaisses[1].name;
    const availableForSecond = maxLength - firstCaisse.length - 2; // -2 for ", "
    
    if (availableForSecond > 10) { // Only truncate if we have reasonable space
      return `${firstCaisse}, ${secondCaisse.substring(0, availableForSecond - 3)}...`;
    } else {
      // Fall back to "2 caisses sélectionnées"
      return '2 caisses sélectionnées';
    }
  }
  
  // For 3+ caisses, ALWAYS show "et X autre caisse" - never truncate this part
  const firstCaisse = assignedCaisses[0].name;
  const secondCaisse = assignedCaisses[1].name;
  const remaining = assignedCaisses.length - 2;
  const suffix = ` et ${remaining} autre${remaining > 1 ? 's' : ''} caisse${remaining > 1 ? 's' : ''}`;
  
  // Calculate available space for caisse names (reserve space for suffix + ", " + "...")
  const reservedSpace = suffix.length + 3; // +3 for ", " and "..."
  const availableForCaisses = maxLength - reservedSpace;
  
  if (availableForCaisses > firstCaisse.length + 5) {
    // We have space for first caisse + part of second caisse
    const availableForSecond = availableForCaisses - firstCaisse.length - 2; // -2 for ", "
    
    if (availableForSecond > 3) {
      return `${firstCaisse}, ${secondCaisse.substring(0, availableForSecond)}...${suffix}`;
    } else {
      // Not enough space for second caisse, just show first caisse
      return `${firstCaisse}...${suffix}`;
    }
  } else {
    // Not enough space even for first caisse, fall back to count
    return `${assignedCaisses.length} caisses sélectionnées`;
  }
};
